import { render, staticRenderFns } from "./AgentReportsPortalList.vue?vue&type=template&id=5da9f448"
import script from "./AgentReportsPortalList.vue?vue&type=script&lang=ts"
export * from "./AgentReportsPortalList.vue?vue&type=script&lang=ts"
import style0 from "./AgentReportsPortalList.vue?vue&type=style&index=0&id=5da9f448&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports